module.exports = __webpack_public_path__ + "media/notification_sound.938be6ed.mp3";